import { hasPersistedUploadFacadeErrorCode, readUploadFacadeErrorCode } from "@uploads/uploadFacadeErrors";
import { supportEmail, supportHint } from "@/helpers/userMessages";
import { uploadControlHeldMessage } from "@uploads/uploadKnownSizeControl";

// These are presentation codes only. Upload classifiers still decide retry and recovery.
const messages: Record<string, () => string> = {
	UPLOAD_CONTROL_UNREADABLE: () => uploadControlHeldMessage(supportEmail()),
	UPLOAD_CONVERSATION_MISMATCH: () => "We couldn't add this file to this session. Please select the file again.",
	UPLOAD_NOT_READY: () => `We couldn't start your upload. Please try again. ${supportHint()}`,
	UPLOAD_RECORDING_RESERVATION_UNSUPPORTED: () => `We couldn't start uploading your video. ${supportHint()}`,
	UPLOAD_IMAGE_RESERVATION_UNSUPPORTED: () => `We couldn't upload this image. Please try again. ${supportHint()}`,
	RECORDING_PART_INDEX_CONFLICT: () => `We're having trouble putting your video together. ${supportHint()}`
};

/** Read typed API codes or their existing durable [CODE] markers, never diagnostic prose. */
export function knownUploadErrorMessage(error: unknown): string | undefined {
	const code = readUploadFacadeErrorCode(error);
	if (code && Object.prototype.hasOwnProperty.call(messages, code)) return messages[code]();
	if (typeof error === "string") {
		for (const [persistedCode, message] of Object.entries(messages)) {
			if (hasPersistedUploadFacadeErrorCode(error, persistedCode)) return message();
		}
	}
	return undefined;
}

/** Only for stopped uploads. Active retries retain the existing progress presentation. */
export function stoppedUploadMessage(error: unknown, canRetry = false): string {
	return knownUploadErrorMessage(error) ??
		(canRetry
			? "Your upload hasn't finished. Select Try again to continue uploading."
			: `We couldn't finish your upload. Please email ${supportEmail()} for help.`);
}
